import { useTranslations } from "next-intl";
import { useSupportEmail } from "@/app/hooks/useSupportEmail";

export const PrivacyPolicyCommon = () => {
  const t = useTranslations();
  const supportEmail = useSupportEmail();

  return (
    <div className="self-stretch flex flex-col justify-start items-start gap-2">
      <div className="self-stretch h-px bg-zinc-200" />
      <div className="self-stretch justify-start text-zinc-900 text-base font-normal font-switzer leading-normal dark:text-sleap-gray-200">
        <ul>
          <li>{t("PrivacyPolicy.thankYouForChoosingToUseGateTravel")}</li>
        </ul>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.informationWeCollect")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.informationWeCollectList.1")}</li>
          </ul>
          <ul className="list-disc pl-6">
            <li>
              {t.rich("PrivacyPolicy.informationWeCollectList.2", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
            <li>
              {t.rich("PrivacyPolicy.informationWeCollectList.3", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
            <li>
              {t.rich("PrivacyPolicy.informationWeCollectList.4", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
            <li>
              {t.rich("PrivacyPolicy.informationWeCollectList.5", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.howWeUseYourInformation")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.howWeUseYourInformationList.1")}</li>
          </ul>
          <ul className="list-decimal pl-6">
            <li>{t("PrivacyPolicy.howWeUseYourInformationList.2")}</li>
            <li>{t("PrivacyPolicy.howWeUseYourInformationList.3")}</li>
            <li>{t("PrivacyPolicy.howWeUseYourInformationList.4")}</li>
            <li>{t("PrivacyPolicy.howWeUseYourInformationList.5")}</li>
            <li>{t("PrivacyPolicy.howWeUseYourInformationList.6")}</li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.informationSharingAndDisclosure")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.informationSharingAndDisclosureList.1")}</li>
          </ul>
          <ul className="list-disc pl-6">
            <li>
              {t.rich("PrivacyPolicy.informationSharingAndDisclosureList.2", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
            <li>
              {t.rich("PrivacyPolicy.informationSharingAndDisclosureList.3", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
            <li>
              {t.rich("PrivacyPolicy.informationSharingAndDisclosureList.4", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
            <li>
              {t.rich("PrivacyPolicy.informationSharingAndDisclosureList.5", {
                strong: (chunks) => <strong>{chunks}</strong>,
              })}
            </li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.dataSecurity")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.dataSecurityList.1")}</li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.yourRights")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.yourRightsList.1", { supportEmail })}</li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.yourConsent")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.yourConsentList.1")}</li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.privacyForMinors")}</strong>
          <ul className="list-disc pl-6">
            <li>{t("PrivacyPolicy.privacyForMinorsList.1")}</li>
            <li>{t("PrivacyPolicy.privacyForMinorsList.2")}</li>
            <li>{t("PrivacyPolicy.privacyForMinorsList.3")}</li>
            <li>{t("PrivacyPolicy.privacyForMinorsList.4")}</li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.internationalDataTransfers")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.internationalDataTransfersList.1")}</li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.modificationsToThePrivacyPolicy")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.modificationsToThePrivacyPolicyList.1")}</li>
          </ul>
        </div>

        <div className="mt-4">
          <strong>{t("PrivacyPolicy.language")}</strong>
          <ul>
            <li>{t("PrivacyPolicy.languageList.1")}</li>
          </ul>
        </div>

        <ul className="mt-4">
          <li>{t("PrivacyPolicy.languageList.2", { supportEmail })}</li>
        </ul>
      </div>
    </div>
  );
};
